"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sanitize = exports.NoteComponent = exports.noteTestId = void 0;
var React = require("react");
var sanitizeHtml = require("sanitize-html");
var textile = require("textile-js");
var Id_1 = require("../common/Id");
/**
 * Test id attribute value (prefix) for certification note component.
 */
exports.noteTestId = 'certification-note';
/**
 * Certification note component.
 * @param props - The props for this certifier user. Note that props are intersected with HTML props so that the styling can changed for
 * different use cases.
 */
function NoteComponent(props) {
    return (React.createElement("div", { "data-tb-test-id": Id_1.generateId(exports.noteTestId, props.id), className: props.className, style: props.style, dangerouslySetInnerHTML: { __html: sanitize(textile(props.note)) } }));
}
exports.NoteComponent = NoteComponent;
/**
 * Sanitizes HTML using the sanitizie-html module. Images need to be explicitly allowed since they are blocked by default.
 * @param dirtyHtml HTML string to sanitize
 */
function sanitize(dirtyHtml) {
    return sanitizeHtml(dirtyHtml, {
        allowedTags: sanitizeHtml.defaults.allowedTags.concat(['img'])
    });
}
exports.sanitize = sanitize;
//# sourceMappingURL=Note.js.map